export var ITEM_TYPES = {
  DEFAULT: 'DEFAULT',
  STATIC_PAGE: 'STATIC_PAGE',
  STATIC_PAGE_V2: 'STATIC_PAGE_V2',
  STORES_PRODUCT: 'STORES_PRODUCT',
  FORUM_POST: 'FORUM_POST',
  FORUM_CATEGORY: 'FORUM_CATEGORY',
  PRO_GALLERY_ITEM: 'PRO_GALLERY_ITEM',
  BLOG_POST: 'BLOG_POST',
  BLOG_CATEGORY: 'BLOG_CATEGORY',
  GROUPS_FEED: 'GROUPS_FEED',
  GROUPS_POST: 'GROUPS_POST',
  GROUPS_MEDIA: 'GROUPS_MEDIA',
  GROUPS_ABOUT: 'GROUPS_ABOUT',
  GROUPS_MEMBERS: 'GROUPS_MEMBERS',
  EVENTS_PAGE: 'EVENTS_PAGE',
  CHALLANGES_PAGE: 'CHALLANGES_PAGE'
};